
const state = {
  planList:{},
  planDetail:{},
  progressList:{},
  pushTimes:0,
  surveyByPlanList:[],
}

const mutations = {
  getPlanList(state, data) {
    state.planList = data || ''
  },
  getPlanDetail(state, data) {
    state.planDetail = data || ''
  },
  getProgressList(state, data) {
    state.progressList = data || ''
  },
  getPushTimes(state, data) {
    state.pushTimes = data || ''
  },
  getSurveyByPlanList(state, data) {
    state.surveyByPlanList = data || ''
  },
}

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/plan.js